/**
 * Created by yqr on 2018/4/13.
 */
import request from '@/utils/request'
import qs from 'qs';

export default {
  webLogin(data) {
    return request({
      url: '/front/webLogin',
      method: 'post',
      params: data
    })
  }
}
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  });
}
export function login(data) {
  return request({
    url: '/front/webLogin',
    method: 'post',
    params: data
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js